import styled from "styled-components";

export const Header = styled.div`
  padding: 11px 20px;
  display: flex;
  align-items: flex-start;
  background: var(--filter-bar-bg);
  gap: 15px;
  justify-content: space-between;
  &.ezLocator-header {
    padding: 6px 20px;
    .ezlocator-section {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 10px 13px;
      .ezlocator-button {
        display: flex;
        align-items: center;
        height: 30px;
        gap: 10px;
        font-size: 14px;
        background-color: #fff;
        color: #000;
        font-family: "Roboto";
        font-weight: 500;
        border-radius: 6px;
        padding: 0 15px;
        border: 1px solid #bc9b6a;
        img {
          max-width: 90px;
        }
      }
      .link-div {
        display: inline-flex;
        align-items: center;
        gap: 9px;
        border-radius: 5px;
    padding: 5px 8px;
    background-color: #fff;
        img {
          max-width: 67px;
        }
        svg {
          path {
            fill: darkblue;
          }
        }
      }
      .pinsheet-time {
        padding: 12px 15px;
        font-size: 14px;
        color: #fff;
        font-family: "Roboto";
        font-weight: 500;
        border-radius: 6px;
        border: 1px solid #bc9b6a;
        background: linear-gradient(0deg, #666666, #666666),
          linear-gradient(0deg, #bc9b6a, #bc9b6a);
     
      }
      @media (max-width: 800px) {
        justify-content: flex-end;
      }
    }
  }

  .for-web {
    display: inline-flex;
  }
  .for-mobile {
    display: none;
  }
  .left-section {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;

    > div {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 0 10px;
      border-left: 1px solid #cdcfd0;
      flex-wrap: wrap;
      /* @media (max-width: 850px) {
        padding: 4px;
      } */
      svg {
        cursor: pointer;
      }
      :first-child {
        border: none;
      }
      .sqr-btn {
        display: flex;
        align-items: center;
        gap: 12px;
        border: 1px solid var(--theme-background);
        border-radius: 6px;
        background: transparent;
        height: 30px;
        padding: 0 8px;
        font-size: 13px;
        color: var(--theme-text);
        &.active {
          background: var(--theme-background);
          border: var(--theme-background);
          border: 1px solid var(--theme-background);
        }
        &.activeAdmin {
          background: var(--admin-tab-bg); color: var(--theme-text); border-color: var(--theme-background);
        }
        &.admin{
          background: var(--admin-tab-bg); color: var(--text-secondary); border-color: var(--side-nav-btn-border-color);
        }
      }

      .internal-div {
        display: flex;
        align-items: center;
        height: 30px;
        border: 1px solid #cdcfd0;
        border-radius: 6px;
        padding: 0 6px 0 8px;
        background: transparent;
        position: relative;

        &.active {
          background: var(--theme-background);
          border: var(--theme-background);
        }
        > button {
          border: none;
          display: flex;
          align-items: center;
          gap: 7px;
          background: transparent;
          font-size: 13px;
          padding-right: 8px;
          color: var(--theme-text);

          position: absolute;
          left: 0;
          z-index: 1;
          &.active {
            color: var(--theme-text);
            border: var(--theme-background);
          }
        }
        .MuiOutlinedInput-notchedOutline {
          display: none;
        }
        .MuiSelect-outlined.MuiSelect-outlined {
          padding: 0;
          width: 132px;
          color: transparent;
          @media (max-width: 850px) {
            width: 35px;
          }
        }
        .MuiInputLabel-root {
          display: none;
        }
        .MuiSelect-iconOutlined {
          right: 0;
          color: var(--theme-text);
          /* background: var(--theme-background); */
        }
      }
      .open-menu {
        display: flex;
        align-items: center;
        padding: 0 10px;
        border-left: 1px solid #cdcfd0;
        padding-right: 0;

        > div {
          padding: 0 10px;
          border-left: 1px solid #cdcfd0;
          :first-child {
            padding-left: 0;
            border: none;
          }
          :last-child {
            padding-right: 0;
          }
        }
      }

      .side-change {
        display: flex;
        align-items: center;
        border: 1px solid var(--theme-background);
        border-radius: 6px;
        height: 30px;
        padding: 1px;
        /* padding: 0 10px;
        border-left: 1px solid #cdcfd0; */
        button {
          display: flex;
          align-items: center;
          border: none;
          background-color: transparent;
          height: 100%;
          color: var(--theme-text);
          .bold {
            font-family: "latoblack";
          }

          &.selected {
            background: var(--theme-background);
            border-radius: 6px;
            border: var(--theme-background);
          }

          img {
            padding-right: 5px;
          }
        }
      }
      .active-rotation {
        display: flex;
        min-width: 200px;
        /* max-width: 200px; */
        border: 1px solid var(--input-background);
        border-radius: 6px;
        background: var(--input-background);
        position: relative;
        height: 30px;
        align-items: center;
        padding-left: 8px;
        padding-right: 37px;
        @media (max-width: 850px) {
          min-width: 156px;
        }
        .label-text {
          /* position: absolute; */
          background: var(--input-background);
          text-align: center;
          border-radius: 6px;
          z-index: 1;
          /* top: 4px;
          left: 8px; */
          /* right: 35px; */
          font-size: 13px;
          line-height: 150.5%;
        }
        .MuiSelect-select {
          padding: 3.5px 14px;
        }
        .MuiFormControl-root {
          position: absolute;
          left: 0;
        }
        .MuiNativeSelect-select .MuiSelect-outlined.MuiSelect-outlined {
          padding-top: 0;
          padding-bottom: 0;
          color: transparent;
        }
        .MuiSelect-iconOutlined {
          background-color: transparent;
          border-radius: 6px;
        }
        .MuiOutlinedInput-notchedOutline,
        .MuiInputLabel-root {
          display: none;
        }
        .MuiFormControl-root {
          width: 100%;
        }
        .text {
          position: absolute;
          font-size: 13px;
        }
        .active-option {
          background-color: grey;
          color: #fff;
          padding: 5px;
          border-radius: 3px;
        }
      }
      .print {
        min-width: 84px;
      }
      .save-btn {
        background: var(--theme-background);
        border: var(--theme-background);
        color: var(--theme-text);
        padding: 10px 10px;
      }

      .btn {
        color: var(--theme-text);
        border-color: var(--theme-background);
      }
    }
  }
  @media (max-width: 850px) {
    padding: 9px 11px;

    .for-mobile {
      display: inline-flex;
    }
    .display {
      display: none;
    }
    .left-section {
      > div {
        border: none;
        padding: 0;

        .for-web {
          display: none;
        }
        .open-menu {
          border: none;
          padding: 0;
          gap: 9px;

          > div {
            border: none;
            padding: 0;
          }
        }
        .side-change {
          border: none;
          gap: 9px;
          button {
            border: 1px solid var(--theme-background);
            border-radius: 6px;
            width: 30px;
            height: 30px;
            padding: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
              padding: 0;
            }
          }
        }
      }
    }
  }
`;

export const RefreshBtn = styled.div`
  button {
    color: var(--theme-text);
    border-color: var(--theme-background);
  }
  @media (max-width: 850px) {
    .mobBtn {
      /* position: absolute;
      right: 30px; */
      border-radius: 6px;
    }
  }
`;

export const Container = styled.div`
  overflow: auto;
`;

export const BodySection = styled.div`
  padding: 0 20px 46px;
  /* display: grid;
  width: 100%;
  grid-template-columns: repeat(auto, auto);
  grid-template-rows: 50px 50px;
  grid-gap: 5px; */
  .ground-select {
    display: flex;
    justify-content: space-between;
    padding-top: 12px;
    .MuiOutlinedInput-root {
      background: #ffffff;
      border: 1px solid #cdcfd0;
      border-radius: 6px;
    }
    .MuiSelect-select,
    .MuiNativeSelect-select {
      padding: 5.5px 14px;
    }
  }
  .box-wrapper {
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    .inner-box {
      display: flex;
      gap: 15px;
      flex-wrap: wrap;
      max-height: calc(100vh - 263px);
      overflow: auto;
    }
    .image-box {
      border-radius: 4px;
      border: 1px solid #000;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
      .grid-area-2 {
        width: 200px;
        height: 200px;
      }

      .inner-image-box {
        width: 250px;
        height: 250px;
        background-color: rgb(34, 85, 32);
      }

      .image-box-holenumber {
        width: 50;
        height: 50;
        background-color: rgb(34, 85, 32);
        position: absolute;
        z-index: 99;
        color: #fff;
        padding: 10;
      }

      .pins-box {
        width: 40px;
        height: 250px;
        border: 1px solid #000;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        z-index: 9;
        background-color: #fff;
      }

      .pins-marker {
        font-size: 10px;
        width: 15px;
        height: 15px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 5px;
        cursor: all-scroll;
        user-select: none;
      }

      .pins-marker-color-1 {
        background-color: #000;
        color: #fff;
      }

      .pins-marker-color-2 {
        background-color: #fff;
        color: #000;
        border: 1px solid black;
      }
      .pins-marker-color-yellow {
        background-color: yellow;
        color: #000;
        border: 1px solid black;
      }
      /* .image-box {
      width: 250px;
      height: 250px;
      background-color: rgb(34, 85, 32);
      border-radius: 4px;
      border: 1px solid #ddd;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .grid-area-2{
        width:200px;
        height: 200px;
      } */

      .image-url {
        /* background-size: 100%; */
        width: 290px;
        height: 250px;
        /* transform:scale(2,1.5) translate(10px,10px); */
      }
      .image-url1 {
        transform: scale(6);
      }

      .colgrid-wrapper {
        width: 85%;
        position: absolute;
        top: 8%;
        left: 8%;
      }
      .colgrid-row {
        /* width:100%; display:flex; */
        display: grid;
        grid-template-rows: 65px 65px 65px;
        grid-template-columns: 70px 70px 70px;
      }
      .colgrid-4 {
        /* max-width:33.33%; flex:0 0 33.33%; border:1px solid #ddd; height:53px; */
        background: transparent;
        border: 1px solid #9e9b9b;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .distance {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
  @media (max-width: 850px) {
    .box-wrapper {
      padding: 10px 0;
      .inner-box {
        justify-content: center;
        max-height: calc(100vh - 277px);
      }
    }
  }
`;
